import fonts from './fonts'
import { pxToRem } from './mixins'

const textStyles = {
  d1440_h1: `
    ${fonts.MonumentGroteskMedium}
    font-size: ${pxToRem(56)};
    line-height: 1;
    letter-spacing: -1%;
  `,
  d1440_h2: `
    ${fonts.MonumentGroteskMedium}
    font-size: ${pxToRem(32)};
    line-height: 1.2;
    letter-spacing: -1%;
  `,
  d1440_h3: `
    ${fonts.MonumentGroteskMedium}
    font-size: ${pxToRem(24)};
    line-height: 1;
    letter-spacing: -1%;
  `,
  d1440_h4: `
    ${fonts.MonumentGroteskMedium}
    font-size: ${pxToRem(20)};
    line-height: 1;
  `,
  d1440_body: `
    ${fonts.MonumentGroteskRegular}
    font-size: ${pxToRem(16)};
    line-height: 1.25;
  `,
  d1440_bodyBig: `
    ${fonts.MonumentGroteskRegular}
    font-size: ${pxToRem(20)};
    line-height: 1.25;
  `,
  d1440_button: `
    ${fonts.MonumentGroteskMedium}
    font-size: ${pxToRem(16)};
    line-height: 1.25;
  `,
  d1440_link: `
    ${fonts.MonumentGroteskRegular}
    font-size: ${pxToRem(16)};
    line-height: 1.25;
  `,
  d1440_tags: `
    ${fonts.MonumentGroteskRegular}
    font-size: ${pxToRem(12)};
    line-height: 1;
  `,
  d1440_keyNumbers: `
    ${fonts.MonumentGroteskRegular}
    font-size: ${pxToRem(88)};
    line-height: 1.25;
    letter-spacing: ${pxToRem(-5)};
    `,
  d1440_keyNumbersSmall: `
    ${fonts.MonumentGroteskRegular}
    font-size: ${pxToRem(64)};
    line-height: 1.25;
    letter-spacing: ${pxToRem(-3)};
    `,
  d1440_editoChapo: `
      ${fonts.MonumentGroteskMedium}
      font-size: ${pxToRem(28)};
      line-height: 1.4;
    `,
  d1440_editoBody: `
      ${fonts.MonumentGroteskRegular}
      font-size: ${pxToRem(18)};
      line-height: 1.5;
    `,
  m375_h1: `
    ${fonts.MonumentGroteskMedium}
    font-size: ${pxToRem(36)};
    // font-size: clamp(${pxToRem(36)}, 4vw + 1rem, ${pxToRem(56)});
    line-height: 1;
    letter-spacing: -1%;
    `,
  m375_h2: `
    ${fonts.MonumentGroteskMedium}
    font-size: ${pxToRem(24)};
    // font-size: clamp(${pxToRem(24)}, 4vw + 1rem, ${pxToRem(32)});
    line-height: 1;
    letter-spacing: -1%;
    `,
  m375_h3: `
    ${fonts.MonumentGroteskMedium}
    font-size: ${pxToRem(20)};
    // font-size: clamp(${pxToRem(20)}, 4vw + 1rem, ${pxToRem(24)});
    line-height: 1;
    letter-spacing: -1%;
  `,
  m375_h4: `
    ${fonts.MonumentGroteskMedium}
    font-size: ${pxToRem(18)};
    // font-size: clamp(${pxToRem(18)}, 4vw + 1rem, ${pxToRem(20)});
    line-height: 1.25;
  `,
  m375_body: `
    ${fonts.MonumentGroteskRegular}
    line-height: 1.25;
    font-size: ${pxToRem(16)};
    line-height: 1.25;
  `,
  m375_bodyBig: `
    ${fonts.MonumentGroteskRegular}
    font-size: ${pxToRem(18)};
    line-height: 1.25;
  `,
  m375_bodySmall: `
    ${fonts.MonumentGroteskRegular}
    font-size: ${pxToRem(14)};
    line-height: 1.25;
  `,
  m375_buttonSmall: `
    ${fonts.MonumentGroteskMedium}
    font-size: ${pxToRem(12)};
    line-height: 1.2;
  `,
  m375_link: `
    ${fonts.MonumentGroteskRegular}
    font-size: ${pxToRem(16)};
    line-height: 1.25;
  `,
  m375_tags: `
    ${fonts.MonumentGroteskRegular}
    font-size: ${pxToRem(12)};
    line-height: 1;
  `,
  m375_keyNumbers: `
    ${fonts.MonumentGroteskRegular}
    font-size: ${pxToRem(64)};
    line-height: 1.25;
    letter-spacing: ${pxToRem(-3)};
    `,
  m375_keyNumbersSmall: `
    ${fonts.MonumentGroteskRegular}
    font-size: ${pxToRem(48)};
    line-height: 1.25;
    letter-spacing: ${pxToRem(-3)};
  `,
  m375_editoChapo: `
    ${fonts.MonumentGroteskMedium}
    font-size: ${pxToRem(20)};
    line-height: 1.4;
  `,
  m375_editoBody: `
    ${fonts.MonumentGroteskRegular}
    font-size: ${pxToRem(16)};
    line-height: 1.5;
  `,
  accessibleHiddenText: `
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0,0,0,0);
    white-space: nowrap;
    border: 0;
  `,
}

export default textStyles
